import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import { CheckCircle as CheckCircleIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { messages } from "../../../../locales/messages";

export const Header: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Card
      elevation={0}
      sx={{
        mb: 4,
        background: "linear-gradient(135deg, #4caf50 0%, #43a047 100%)",
        color: "white",
        borderRadius: 3,
      }}
    >
      <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Box display="flex" alignItems="center" mb={2}>
          <CheckCircleIcon sx={{ fontSize: 32, mr: 2 }} />
          <Typography
            variant="h4"
            component="h1"
            sx={{
              fontWeight: 700,
              fontSize: { xs: "1.75rem", sm: "2.125rem" },
            }}
          >
            {t(messages.Review_Complete())}
          </Typography>
        </Box>
        <Typography
          variant="h6"
          sx={{
            opacity: 0.95,
            fontSize: { xs: "1rem", sm: "1.125rem" },
            fontWeight: 400,
            lineHeight: 1.6,
          }}
        >
          {t(
            messages.Please_review_all_your_store_information_before_completing_the_setup()
          )}{" "}
          {t(messages.You_can_still_make_changes_if_needed())}
        </Typography>
      </CardContent>
    </Card>
  );
};
